export const GetStudentListConst = "GetStudentList";
export const GetDegreeListConst="GetDegreeList";
export const GetStudentChatByIdConst="GetStudentChatById"
export const GetStudentNotesByIdConst="GetStudentNotesById"
export const GetStudentReminderByIdConst="GetStudentReminderById"
export const GetAllBranchListConst="GetAllBranchList"
export const GetUnsettledListConst="GetUnsettledList"
export const GetAgentTransactionListConst="GetAgentTransactionList"
